import { ISetOwnerParams } from '../types/actionParams';
import { IResult } from '../types/IResponse';
import { Request } from './Request';

export class SetDataRolesOwnerRequest extends Request<ISetOwnerParams, IResult> {
  constructor(ids: string[], ownerId: string) {
    super('setDataRolesOwner', {
      ids: ids,
      ownerId: ownerId
    });
  }
}
